<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div class="flex gap-2 w-full bg-white items-center">
      <img src="../../assets/image/search.svg" alt="" class="" />
      <input
        placeholder="Search Provider Name Here..."
        (keyup)="onKeyUp($event, pagination)"
        class="w-full border p-2 rounded-md outline-none"
      />
      <select
        class="border p-2 rounded-[10px] bg-gradient-to-r from-primary to-semiPrimary text-white outline-none text-white"
        (change)="getAllProviderViaFilter($event)"
      >
        <option value="" selected>Select Filter</option>
        <option value="PayIn" class="bg-white text-black">Pay In</option>
        <option value="PayOut" class="bg-white text-black">Pay Out</option>

        <option value="PayIn/PayOut" class="bg-white text-black">
          PayIn/PayOut
        </option>
      </select>

      <div class="flex-none" *ngIf="permissions.includes('provider-create')">
        <app-primary-button (click)="openToCreate()">
          <div class="flex gap-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            Add Provider
          </div></app-primary-button
        >
      </div>
    </div>
  </div>
  <div class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-auto">
    <table
      class="w-[100%] text-left h-full overflow-y-auto"
      *ngIf="providerList?.length > 0"
    >
      <tr class="h-8">
        <th>Sr No.</th>
        <th>Provider Name</th>
        <th>Tx Type</th>
        <th>Host Name</th>
        <th>User Name</th>
        <th>Method</th>

        <th
          *ngIf="
            permissions.includes('provider-edit') ||
            permissions.includes('provider-view')
          "
        >
          View
        </th>
        <th
          *ngIf="
            permissions.includes('provider-edit') ||
            permissions.includes('provider-view')
          "
        >
          Edit
        </th>
      </tr>
      <tr
        *ngFor="let item of providerList; let i = index"
        class="h-8 p-2"
        [ngStyle]="{
          backgroundColor:
            i % 2 == 0
              ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
              : 'white'
        }"
      >
        <td class="">{{ i + 1 + (pagination.currentPage - 1) * 10 }}</td>

        <td class="">{{ item.providerName | titlecase }}</td>
        <td class="">{{ item.txType }}</td>
        <td>{{ item.host | titlecase }}</td>
        <td>{{ item.hostList | titlecase }}</td>
        <td>{{ item.method | titlecase }}</td>

        <!-- <td class="px-6"> -->
        <!-- <button (click)="editForm(i)"> -->
        <!-- <button routerLink="/home/administration/editPortalBuilder"> -->
        <!-- </button> -->
        <!-- </td> -->

        <td (click)="viewForm(i)" *ngIf="permissions.includes('provider-view')">
          <img title="Edit" src="../../../../assets/image/eye.svg" />
        </td>
        <td *ngIf="permissions.includes('provider-edit')" (click)="editForm(i)">
          <img title="Edit" src="../../../../assets/image/edit.svg" />
        </td>
      </tr>
    </table>
    <app-empty-data
      *ngIf="providerList.length < 1"
      class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/11.png'"
      [message]="'No data available'"
    ></app-empty-data>
  </div>
  <app-next-preview-button
    [limit]="pagination.limit"
    [currentPage]="pagination.currentPage"
    [totalPage]="totalPage"
    [totalRecords]="totalRecords"
    (next)="nextPage()"
    (previous)="previousPage()"
    (pageChange)="onPageChange($event)"
    (last)="onLast()"
    (first)="onFirst()"
  ></app-next-preview-button>
</div>

<div
  *ngIf="addProvider"
  class="h-screen w-full bg-black/40 flex overflow-hidden justify-end fixed top-0 right-0"
>
  <div class="bg-white w-[500px]">
    <div
      class="p-2 px-5 w-full bg-primary text-white h-16 flex justify-between items-center"
    >
      <span *ngIf="!isUpdated">Add Provider</span>
      <span *ngIf="isUpdated">Update Provider</span>
      <span (click)="closeFormDialog()" class="text-2xl">
        <img src="../../assets/image/x.svg" alt="" />
      </span>
    </div>
    <div class="p-2 h-[90%] overflow-y-auto">
      <form [formGroup]="providerForm">
        <div class="bg-white border rounded-xl">
          <div class="border gap-2 py-4">
            <span
              class="px-4 border-l-primary py-4 border-[3px] border-transparent"
              >Provider Details</span
            >
          </div>
          <div class="p-4 flex flex-col gap-4">
            <div class="flex flex-col p-2">
              <span>Provider Name</span>
              <input
                formControlName="providerName"
                name="pname"
                type="text"
                placeholder="Enter Provide Name"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['providerName'].touched &&
                  !providerForm.controls['providerName'].valid
                "
                class="text-red-500"
              >
                Please Provide Provider Name
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Tx Type</span>
              <select
                formControlName="txType"
                class="p-2 outline-none border rounded-md"
              >
                <option value="" disabled selected class="text-gray-300">
                  -- Select User Type --
                </option>

                <option value="PayIn">Pay In</option>
                <option value="PayOut">Pay Out</option>

                <option value="PayIn/PayOut">Pay In / Pay Out</option>
              </select>
            </div>
            <div
              *ngIf="
                providerForm.controls['txType'].touched &&
                !providerForm.controls['txType'].valid
              "
              class="text-red-500"
            >
              Please Select Tx Type
            </div>

            <!-- // -->
            <div class="flex flex-col p-2 gap-4">
              <span> Select Partner</span>
              <div class="dropdown">
                <button class="dropdown-button" (click)="toggleDropdown()">
                  Select Partners <span class="arrow">&#9660;</span>
                </button>
                <div class="dropdown-content" [class.hidden]="!isOpen">
                  <div *ngFor="let partner of allPartner" class="checkbox-item">
                    <input
                      type="checkbox"
                      [id]="partner._id"
                      [checked]="selectedPartners.includes(partner._id)"
                      (change)="onCheckboxChange(partner._id, $event)"
                    />
                    <label [for]="partner._id">{{ partner.name }}</label>
                  </div>
                </div>
              </div>
              <!-- <div class="h-52 overflow-hidden border p-2 shadow-inner">
                <div class="flex gap-4 p-1 overflow-x-auto flex-none">
                  <button
                    (click)="onItemClick(item, true)"
                    *ngFor="let item of selectedPartner"
                    class="bg-primary p-1 px-4 text-white rounded-md flex gap-3 items-center flex-none"
                  >
                    <span> {{ item }}</span>
                    <img src="../../../../assets/image/x.svg" />
                  </button>
                </div>
                <div
                  class="flex flex-col shadow-inner gap-2 h-40 overflow-y-auto"
                >
                  <button
                    *ngFor="let item of allPartner"
                    class="flex space-y-4 flex-col hover:bg-gray-600 hover:text-white w-full p-1 px-4 rounded-md"
                    (click)="onItemClick(item, false)"
                  >
                    <span> {{ item.name }}</span>
                  </button>
                </div>
              </div> -->
            </div>
            <!-- <div class="flex flex-col p-2 gap-2">
              <span> Select Partner</span>
              <select class="border w-full outline-none p-2 rounded-md">
                <option disabled selected>--Select Partner--</option>
                <option
                  *ngFor="let item of allPartner"
                  class="flex flex-col gap-1"
                >
                  <div class="flex space-x-4">
                    <input type="checkbox" formControlName="partners"/>
                    <span> {{ item.name }}</span>
                  </div>
                </option>
              </select>
            </div> -->
            <div
              *ngIf="
                providerForm.controls['partners'].touched &&
                !providerForm.controls['partners'].valid
              "
              class="text-red-500"
            >
              Please Select partner
            </div>
            <div class="flex flex-col p-2">
              <span>Host</span>
              <input
                formControlName="host"
                name="host"
                type="text"
                placeholder="Enter Host"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['host'].touched &&
                  !providerForm.controls['host'].valid
                "
                class="text-red-500"
              >
                Please Provide Host Name
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Host List</span>

              <input
                formControlName="hostList"
                name="host-List"
                type="text"
                class="w-full p-2 outline-none border rounded-md"
                placeholder="Enter host name"
              />
            </div>
            <div
              *ngIf="
                providerForm.controls['hostList'].touched &&
                !providerForm.controls['hostList'].valid
              "
              class="text-red-500"
            >
              Please Provide Host List
            </div>
            <div class="flex flex-col p-2">
              <span>Port</span>
              <input
                formControlName="port"
                name="port"
                type="text"
                placeholder="Enter Port"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['port'].touched &&
                  !providerForm.controls['port'].valid
                "
                class="text-red-500"
              >
                Please Provide Port Name
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Method</span>
              <select
                formControlName="method"
                name="method"
                class="w-full p-2 outline-none border rounded-md"
              >
                <option value="" selected disabled>Select Method</option>
                <option value="Get">Get</option>
                <option value="Post">Post</option>
              </select>
              <!-- <input
                formControlName="method"
                name="method"
                type="text"
                placeholder="Enter Method"
                class="w-full border p-2 rounded-md outline-none"
              /> -->
              <div
                *ngIf="
                  providerForm.controls['method'].touched &&
                  !providerForm.controls['method'].valid
                "
                class="text-red-500"
              >
                Please Provide Method
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Request URL</span>
              <input
                formControlName="requestUrl"
                name="requestUrl"
                type="text"
                placeholder="Enter Request URL"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['requestUrl'].touched &&
                  (!providerForm.controls['requestUrl'].valid ||
                    providerForm.controls['requestUrl']?.hasError('pattern'))
                "
                class="text-red-500"
              >
                Please Provide Request Url
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Header Type</span>
              <select
                formControlName="headerType"
                name="headerType"
                type="text"
                class="w-full p-2 outline-none border rounded-md"
              >
                <option value="" disabled selected>Select header type</option>
                <option value="application/json">application/json</option>
                <option value="application/text">application/text</option>
              </select>
              <div
                *ngIf="
                  providerForm.controls['headerType'].touched &&
                  !providerForm.controls['headerType'].valid
                "
                class="text-red-500"
              >
                Please Provide Header Type
              </div>
            </div>

            <div class="flex flex-col p-2">
              <span>URL</span>
              <input
                formControlName="url"
                name="url"
                type="text"
                placeholder="Select Url"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['url'].touched &&
                  (!providerForm.controls['url'].valid ||
                    providerForm.controls['url']?.hasError('pattern'))
                "
                class="text-red-500"
              >
                Please Provide Url
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>User Name</span>
              <input
                placeholder="Enter User Name"
                formControlName="userName"
                name="username"
                type="text"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['userName'].touched &&
                  !providerForm.controls['userName'].valid
                "
                class="text-red-500"
              >
                Please User Name
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Password</span>
              <input
                formControlName="password"
                name="password"
                type="password"
                placeholder="Enter Password"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['password'].touched &&
                  !providerForm.controls['password'].valid
                "
                class="text-red-500"
              >
                Please Provide Password
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Queue Code</span>
              <input
                formControlName="code"
                name="code"
                type="text"
                placeholder="Enter Queue Code"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['code'].touched &&
                  !providerForm.controls['code'].valid
                "
                class="text-red-500"
              >
                Please Provide Code
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Target Destination</span>
              <input
                formControlName="targetDestination"
                name="targetDestination"
                type="text"
                placeholder="Enter Target Destination"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  providerForm.controls['targetDestination'].touched &&
                  !providerForm.controls['targetDestination'].valid
                "
                class="text-red-500"
              >
                Please Provide Target Destination
              </div>
            </div>
            <div class="flex flex-col p-2">
              <span>Settlement Type</span>
              <div>
                <input
                  type="radio"
                  id="Instant"
                  formControlName="settlementType"
                  value="A"
                  checked
                />
                <label for="Instant">Instant</label><br />
                <input
                  type="radio"
                  id="T+1"
                  formControlName="settlementType"
                  value="B"
                />
                <label for="T+1">T+1</label><br />
              </div>
            </div>
          </div>
          <div class="flex justify-center items-center py-2">
            <button
              *ngIf="!isUpdated"
              type="button"
              (click)="createProvider()"
              class="p-2 px-5 w-56 rounded-xl bg-primary text-white h-10 text-center"
            >
              <span>Submit</span>
            </button>
            <button
              *ngIf="isUpdated"
              [disabled]="!providerForm.valid"
              type="button"
              (click)="updateProvider()"
              class="p-2 px-5 w-56 rounded-xl bg-primary text-white h-10 text-center"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  *ngIf="viewProvider"
  class="h-screen w-full bg-black/40 flex overflow-hidden justify-end fixed top-0 right-0"
>
  <div class="bg-white w-[500px]">
    <div
      class="p-2 px-5 w-full bg-primary text-white h-16 flex justify-between items-center"
    >
      <span *ngIf="viewProvider">View Provider</span>
      <span (click)="closeFormDialog()" class="text-2xl">
        <img src="../../assets/image/x.svg" alt="" />
      </span>
    </div>
    <div class="p-2 h-[90%] overflow-y-auto">
      <form [formGroup]="providerForm">
        <div class="bg-white border rounded-xl">
          <div class="border gap-2 py-4">
            <span
              class="px-4 border-l-primary py-4 border-[3px] border-transparent"
              >Provider Details</span
            >
          </div>
          <div class="p-4 flex flex-col gap-4">
            <div class="flex flex-col p-2">
              <span>Provider Name</span>
              <input
                formControlName="providerName"
                readonly
                name="pname"
                type="text"
                placeholder="Enter Provide Name"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Tx Type</span>
              <select
                formControlName="txType"
                readonly
                name="txType"
                type="text"
                placeholder="Select"
                class="w-full p-2 outline-none border rounded-md"
              >
                <span class="text-sm">Select User Type</span>

                <option value="PayIn">Pay In</option>
                <option value="PayOut">Pay Out</option>

                <option value="PayIn/PayOut">PayIn/PayOut</option>
              </select>
            </div>

            <div class="flex flex-col p-2 gap-4">
              <span> Select Partner</span>
              <div class="dropdown">
                <button class="dropdown-button" (click)="toggleDropdown()">
                  Select Partners <span class="arrow">&#9660;</span>
                </button>
                <div class="dropdown-content" [class.hidden]="!isOpen">
                  <div *ngFor="let partner of allPartner" class="checkbox-item">
                    <input
                      disabled
                      type="checkbox"
                      [id]="partner._id"
                      [checked]="selectedPartners.includes(partner._id)"
                      (change)="onCheckboxChange(partner._id, $event)"
                    />
                    <label [for]="partner._id">{{ partner.name }}</label>
                  </div>
                </div>
              </div>
              <!-- <div class="h-52 overflow-hidden border p-2 shadow-inner">
                <div class="flex gap-4 p-1 overflow-x-auto flex-wrap">
                  <button
                  readonly
                    (click)="onItemClick(item, true)"
                    *ngFor="let item of selectedPartner"
                    class="bg-primary p-1 px-4 text-white rounded-md flex gap-3 items-center"
                  >
                    <span> {{ item }}</span>
                    <img src="../../../../assets/image/x.svg" />
                  </button>
                </div>
                <div
                  class="flex flex-col shadow-inner gap-2 h-40 overflow-y-auto"
                >
                  <button
                  readonly
                    *ngFor="let item of allPartner"
                    class="flex space-y-4 flex-col hover:bg-gray-600 hover:text-white w-full p-1 px-4 rounded-md"
                    (click)="onItemClick(item.name, false)"
                  >
                    <span> {{ item.name }}</span>
                  </button>
                </div>
              </div> -->
            </div>
            <div class="flex flex-col p-2">
              <span>Host</span>
              <input
                formControlName="host"
                readonly
                name="host"
                type="text"
                placeholder="Enter Host"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Host List</span>

              <input
                formControlName="hostList"
                readonly
                name="host-List"
                type="text"
                class="w-full p-2 outline-none border rounded-md"
                placeholder="Enter host name"
              />
            </div>

            <div class="flex flex-col p-2">
              <span>Port</span>
              <input
                formControlName="port"
                readonly
                name="port"
                type="text"
                placeholder="Enter Port"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Method</span>
              <input
                formControlName="method"
                readonly
                name="method"
                type="text"
                placeholder="Enter Method"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Request URL</span>
              <input
                formControlName="requestUrl"
                readonly
                name="requestUrl"
                type="text"
                placeholder="Enter Request URL"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Header Type</span>
              <select
                formControlName="headerType"
                name="headerType"
                type="text"
                class="w-full p-2 outline-none border rounded-md"
              >
                <option value="application/json">application/json</option>
                <option value="application/text">application/text</option>
              </select>
            </div>

            <div class="flex flex-col p-2">
              <span>URL</span>
              <input
                formControlName="url"
                readonly
                name="url"
                type="text"
                placeholder="Select Url"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>User Name</span>
              <input
                placeholder="Enter User Name"
                formControlName="userName"
                readonly
                name="username"
                type="text"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Password</span>
              <input
                formControlName="password"
                readonly
                name="password"
                type="password"
                placeholder="Enter Password"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Queue Code</span>
              <input
                formControlName="code"
                readonly
                name="code"
                type="text"
                placeholder="Enter Queue Code"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Target Destination</span>
              <input
                formControlName="targetDestination"
                readonly
                name="targetDestination"
                type="text"
                placeholder="Enter Target Destination"
                class="w-full border p-2 rounded-md outline-none"
              />
            </div>
            <div class="flex flex-col p-2">
              <span>Settlement Type</span>
              <div>
                <input
                  [disabled]="true"
                  type="radio"
                  id="Instant"
                  formControlName="settlementType"
                  value="A"
                  checked
                />
                <label for="Instant">Instant</label><br />
                <input
                  type="radio"
                  id="T+1"
                  formControlName="settlementType"
                  value="B"
                />
                <label for="T+1">T+1</label><br />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
